import { AxiosResponse } from 'axios';
import axios from './api';

import { CheckLoginResponse, GetMeType, GetMeResponse, CheckLogoutResponse, PingResponse } from './account.types';

export type { GetMeType };

/*
 * Sækja innskráðan notanda
 */
export const getMe = async (): Promise<GetMeType> => {
  const response = await axios.get<GetMeResponse>('/vala/application-auth/check-user');

  if (response.data.items.length === 0) {
    throw new Error('NotFound');
  }

  return response.data.items[0];
};

export const checkLogin = (token: string): Promise<AxiosResponse<CheckLoginResponse>> => {
  return axios.post<CheckLoginResponse>(
    '/vala/application-auth/check-login',
    {
      onetime: token,
    },
    {
      requireAuth: false,
    }
  );
};

export const checkLogout = (token: string): Promise<AxiosResponse<CheckLogoutResponse>> => {
  return axios.post<CheckLogoutResponse>('/vala/application-auth/logout', {
    token,
  });
};

export const ping = async (): Promise<PingResponse> => {
  const response = await axios.get<PingResponse>('/vala/application-auth/ping', { skipRefresh: true });

  if (!response.data.timeleft) {
    throw new Error('NotFound');
  }

  return response.data;
};
